const backendURL = "https://restapi.joburst.com/"
const mongoDBURL = "https://mongo.joburst.com/"
export {
    backendURL,
    mongoDBURL
}